import styled from 'styled-components';

import { StatusCell } from '@/features/vfo/components/';
import { breakpoints, media } from '@/shared/components';
import { Drawer } from '@/shared/components/drawer';
import { COLORS } from '@/shared/constants/colors';
import { Link } from '@/shared/uikit/Link';
import { Button } from '@/shared/uikitV2/Button';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Body = styled.div`
  padding: 24px 24px 0 24px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-height: calc(100% - 92px);
  height: 100%;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 24px;
  gap: 12px;
`;

export const ProfileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background: ${COLORS.systemLight200};
  border-radius: 24px;
  padding: 16px;
  position: relative;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Label = styled.div`
  color: ${COLORS.systemDark200};
  width: 123px;
`;

export const Value = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Tag = styled.b`
  font-size: 11px;
  letter-spacing: 0.2;
  line-height: 16px;
  color: ${COLORS.systemDark200};
`;

export const CaseList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CaseItem = styled.div`
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid ${COLORS.systemDark100};
`;

export const CaseName = styled(Link)`
  &&& {
    color: ${COLORS.systemSky200}!important;
    line-height: 20px;
  }
`;

export const UserName = styled.b`
  font-size: 18px;
  line-height: 20px;
`;

export const Email = styled.span`
  font-size: 14px;
  color: ${COLORS.systemDark200};
  line-height: 20px;
  margin-top: -2px;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: calc(100% -48px);

  ${media.md}, ${breakpoints.sm} {
    max-width: calc(100% - 72px);
  }
`;

export const StatusCellStyled = styled(StatusCell)`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const ButtonLogout = styled(Button)`
  &&& {
    color: ${COLORS.systemFlame200};

    &:hover {
      color: ${COLORS.systemFlame300} !important;
    }
  }
`;

export const FounderWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const InfoBlock = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InvitationPending = styled.span`
  color: ${COLORS.systemDark200};
  text-align: center;
`;

export const Spaced = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
